<template>
  <el-dialog
    v-dialogDrag
    title="隐患整改通知单"
    :visible.sync="visible"
    :close-on-click-modal="false"
    class="large-dialog"
    width="1280px"
  >
    <div>
      <div class="pdf-panel px-10px" ref="card">
        <div class="w-full text-3xl h-60px leading-60px">{{ displayName }}企业隐患整改通知单</div>
        <div class="h-20px leading-20px text-right">
          单位：<span class="mr-40px">{{
            formData.personChargeHiddenDangerRectificationDepartment
          }}</span>
          日期：<span class="mr-10px">{{
            formData.startRectificationTime
              ? dayjs(formData.startRectificationTime).format('YYYY/MM/DD HH:mm:ss')
              : '-'
          }}</span>
        </div>

        <div class="table-form border-1 border-color-default">
          <table class="table-body w-full">
            <tbody class="text-sm">
              <tr class="border-b-1 border-color-default">
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患描述:</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell" colspan="3">
                  <div
                    class="text-color-primary font-normal w-900px flex justify-center"
                    :title="formData.hiddenDangerName"
                  >
                    <span>{{ formData.hiddenDangerName }}</span>
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 border-color-default">
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患类别:</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full flex justify-center"
                    :title="formData.hiddenDangerCategoryStr"
                  >
                    <span>{{ formData.hiddenDangerCategoryStr }}</span>
                  </div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">所在区域</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full flex justify-center"
                    :title="formData.areaStr"
                  >
                    <span>{{ formData.areaStr }}</span>
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 border-color-default">
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患来源</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full flex justify-center"
                    :title="formData.hiddenDangerSourceStr"
                  >
                    <span>{{ formData.hiddenDangerSourceStr }}</span>
                  </div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患上报人</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full flex justify-center"
                    :title="formData.reporterName"
                  >
                    <span>{{
                      departPersonText(formData.reporterDepartment, formData.reporterName)
                    }}</span>
                  </div>
                </td>
              </tr>

              <tr class="border-b-1 border-color-default">
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患限期整改</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="text-color-primary font-normal w-full flex justify-center">
                    <span>
                      {{
                        formData.hiddenDangerRectificationPeriod
                          ? dayjs(formData.hiddenDangerRectificationPeriod).format(
                              'YYYY/MM/DD HH:mm:ss'
                            )
                          : ''
                      }}
                    </span>
                  </div>
                </td>
              </tr>

              <tr class="border-b-1 border-color-default">
                <!-- <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患类型</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full flex justify-center"
                    :title="formData.hiddenDangerTypeStr"
                  >
                    <span>{{ formData.hiddenDangerTypeStr }}</span>
                  </div>
                </td> -->

                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患可能危害</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full flex justify-center"
                    :title="formData.hiddenDangerHarm"
                  >
                    <span>{{ formData.hiddenDangerHarm }}</span>
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 border-color-default">
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患等级</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full flex justify-center"
                    :title="formData.hiddenDangerlevelStr"
                  >
                    <span>{{ formData.hiddenDangerlevelStr }}</span>
                  </div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">风险等级</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full w-full flex justify-center"
                    :title="formData.riskLevel | riskLevelMap"
                  >
                    <span>{{ formData.riskLevel | riskLevelMap }}</span>
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 border-color-default">
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患归属专业</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div
                    class="text-color-primary font-normal w-full w-full flex justify-center"
                    :title="formData.hiddenDangersBelongProfessionStr"
                  >
                    <span>{{ formData.hiddenDangersBelongProfessionStr }}</span>
                  </div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患审核人</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="text-color-primary font-normal w-full w-full flex justify-center">
                    <span>
                      {{
                        departPersonText(
                          formData.hiddenDangerVerifierPersonDepartment,
                          formData.hiddenDangerVerifierPersonName
                        )
                      }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 border-color-default">
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="text-color-primary font-normal w-full flex justify-center">
                    <span>
                      {{
                        departPersonText(
                          formData.personChargeHiddenDangerRectificationDepartment,
                          formData.personChargeHiddenDangerRectificationName
                        )
                      }}
                    </span>
                  </div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">隐患验收负责人</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="text-color-primary font-normal w-full flex justify-center">
                    <span>
                      {{
                        departPersonText(
                          formData.personChargeHiddenDangerAcceptanceDepartment,
                          formData.personChargeHiddenDangerAcceptanceName
                        )
                      }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 border-color-default">
                <td class="border-r-1 border-color-default p-10px table-cell">
                  <div class="font-bold text-color-primary">整改要求</div>
                </td>
                <td class="border-r-1 border-color-default p-10px table-cell" colspan="3">
                  <div
                    class="text-color-primary font-normal w-900px flex justify-center"
                    :title="formData.hiddenDangerOpinionsRectification"
                  >
                    <span>{{ formData.hiddenDangerOpinionsRectification }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button type="primary" size="small" @click="exportRiskCard" :disabled="saveLoading"
        >打印</el-button
      > -->
      <el-button type="primary" size="small" @click="exportRiskCard" :disabled="saveLoading"
        >导出PDF</el-button
      >
      <el-button @click="$emit('cancel')" size="small">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { OrganizationApi } from '@wiz-api/account'
import html2pdf from '@/components/safety/enumField/pdfPage'

const organizationApi = new OrganizationApi()

export default {
  name: 'bank-risk-card',
  components: {},
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
  },
  filters: {
    riskLevelMap(val) {
      const riskLevelList = [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ]
      return riskLevelList.find((i) => {
        return i.code === val
      })?.displayName
    },
  },
  data() {
    return {
      visible: true,
      displayName: '',
      ruleForm: {},
      saveLoading: false,
      collapseActiveName: ['baseInfo', 'risk', 'evaluate', 'control'],
      tableData: [],
      controlData: [
        {
          controls: '',
        },
      ],
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  created() {
    this.getTelantInfo()
  },
  methods: {
    departPersonText(departParse, personParse) {
      const depart = departParse || ''
      const person = personParse || ''
      return `${depart} ${person}`
    },
    // 获取企业信息
    async getTelantInfo() {
      this.saveLoading = true
      const [err, res] = await organizationApi.getAllListDetails()
      if (!err) {
        this.displayName = res.items[0]?.displayName
      }
      this.saveLoading = false
    },
    // 导出pdf
    exportRiskCard() {
      const pdfName = `${this.displayName}企业隐患整改通知单`
      html2pdf(this.$refs.card, pdfName)
    },
  },
}
</script>

<style scoped lang="scss">
.table-form {
  td:last-child {
    border-right: none;
  }
  .table-body {
    tr:last-child {
      border: none;
    }
    td:first-child {
      border-left: none;
    }
  }
  td {
    width: 25%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }
}

::v-deep .el-card .el-card__header {
  padding: 10px;
}

::v-deep .custom-card {
  border-bottom: none !important;
}

::v-deep .el-card .el-card__header {
  padding: 0 !important;
}
</style>
